export default {
  pageTitle: '選考設定',
  positionSettings: '求人設定',
  candidateSettings: '候補者設定',
  settings: '設定',

  // 選考フロー
  selectionProcess: '選考フロー',
  selectionProcessDescription: '選考フローを設定できます。\n 求人を作成する際に、該当する選考フローを選択してください',

  // 面試評価軸
  interviewEvaluation: '面試評価軸',
  interviewEvaluationDescription: '設置面試評価模板的維度及権重、方便面試官更全面地評価候選人、適用於面試模板和 AI 評分。',

  // 应聘渠道
  applicationSource: '応募チャンネル',
  applicationSourceDescription: '応募チャンネルを設定できます。\n 候補者を登録する際に、該当する応募チャンネルを選択してください',
};
